export const environment = {
  production: false,
  apiUrl: 'https://rptmngapiv2test.clavisco.com/',
};
